import React, { useCallback, useContext, useState,useEffect,useMemo, useReducer} from "react";
import { ModalNextContext,Card} from '@jutro/components';
import { Link } from '@jutro/router';
import { InputField, InputNumberField, CurrencyField} from '@jutro/legacy/components';
import { Flex, FlexItem,Grid, GridItem } from '@jutro/layout';

import { ViewModelServiceContext,ViewModelForm,useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { useTranslator, FormattedMessage,IntlContext } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import _, { forEach, isArguments, random } from "lodash";
import moment from 'moment';
import  usecpmiAnalytics from "account-management/src/hooks/usecpmiAnalytics";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
import metadata from "./CPMIStartPayrollGL.metadata.json5";
import styles from "./CPMIStartPayrollGL.module.scss";
import messages from "./CPMIStartPayrollGL.messages";
import PayrollReviewGL from '../PayrollReviewGL/PayrollReviewGL';
// import CPMIClassCodeComponent from "./CPMIClassCodeComponent/CPMIClassCodeComponent";
// import CPMIClassCodeComponentGL from "./CPMIClassCodeComponentGL/CPMIClassCodeComponent";

const isBlank = (value) => value === undefined || value === null || value === '';

const hasBlankCompositeAudited = (data) =>
    data?.gl7States?.some(state =>
        state?.subLinePresenters?.some(sub =>
            sub?.gl7PayrollLocation?.some(loc =>
                !loc.exposureId && (loc.auditedExposureAmount === undefined || loc.auditedExposureAmount === '')
            )
        )
    ) ?? false;

function CPMIStartPayrollGL(props) {
    const ModalNext=useContext(ModalNextContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { authHeader } = useAuthentication();
    const [payrollVM,setPayrollVM] = useState([])
    const[trackPageView,trackEvent] = usecpmiAnalytics();
    const[trackGAPageView] = useGoogleAnalytics();
    const [payrollData,setPayrollData]=useState({})
    const { refreshData } = useDataRefresh()
    const [isLoading, setIsLoading] = useState(false)
    const [draftmsg,setdraftmsg]=useState(false)
    const [warningmsg,setwarningmsg]=useState(false);
    const [reviewData,setreviewData]=useState([])
    const [viewStartPage,setviewStartPage]=useState(true)
    const [stateData,setstateData]=useState([])
    const [totalData,settotalData]=useState({
        empCount:0,
        grossAmount:0
    })
    const [randomNumber,setrandomNumber]=useState(0);
    const [blankValues,setblankValues]=useState(false)
    const [refresh,setRefresh]=useState(null)
    const [PremptionError,setShowPremptionError]=useState(false)
    const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
    const {
        history,
        location:{
            state,
            state:{appValue}
        }
    }=props
    const [startPayrollButtonClicked,setstartPayrollButtonClicked] = useState(props?.history?.location?.state?.page)
    const [payrollButtonCLickedFlag, setPayrollButtonCLickedFlag]=useState(props?.history?.location?.state?.payrollFlag);
    const [disabledNext,setdisabledNext]=useState(true)
    

    //New variable
    const [premisesOperationExposure,setPremisesOperationExposure] =useState(null);
    const [productsCompletedOperationsExposure,setProductsCompletedOperationsExposure] =useState(null);
    const [changeValuesZero,setChangeValuesZero] = useState(false);
    let subLineText;

    useEffect(() => {
        trackPageView("start payroll","/startpayrollGL")
    },[])

    useEffect(() => {
        trackGAPageView("/startpayrollGL","Start/Edit Payroll")
    },[])

    useEffect(()=>{},[randomNumber])

    const CheckforPremption = useCallback((res)=>{
        if(res.hasPreemptions){
            setShowPremptionError(true)
        }
        else{
            setShowPremptionError(false)
        }
    },[])

    const setFinalpayrollData=useCallback((payroll)=>{
        if (Object.keys(payroll).length !== 0) {
            const arrayFlag = [];

            // eslint-disable-next-line array-callback-return
            payroll?.gl7States?.map((stateLoopItem, index) => {
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {
                    const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => ((item.auditedExposureAmount === undefined || item.auditedExposureAmount === "") && subLimeLoopItem.subLineName !== "Premises/Operations and Products/Completed Operations"))
                    const filterResultPrem = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => item.exposureId > 0 && (item.auditedExposureAmount === undefined || item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === undefined || item.auditedProdsCompltdOpsExposureAmount === "") && (subLimeLoopItem.subLineName === "Premises/Operations and Products/Completed Operations"))                   
                    
                    if (filterResult.length > 0) {
                        arrayFlag.push(filterResult.length);
                    }
                    if (filterResultPrem.length > 0) {
                        arrayFlag.push(filterResultPrem.length);
                    }

                })

            })

            if (hasBlankCompositeAudited(payroll)) {
                arrayFlag.push('composite');
            }
            if (arrayFlag.length > 0) {
                setdisabledNext(true);
            } else {
                setdisabledNext(false);
            }
        }
    },[])

    const getInProgressReportPeriod=useCallback(()=>{

        if(appValue==="PE"){
            //get glpayroll details 
            PayrollService.PEgetInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{
                setPayrollData(res);
                CheckforPremption(res);
                setFinalpayrollData(res)
                res?.gl7States?.map((stateLoopItem,index)=>{
                    stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                        // if(payrollButtonCLickedFlag  ==="Edit Payroll"){
                        //     const arrayFlag = [];

                        //     const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item)=>(item.auditedExposureAmount ==="" || item.auditedProdsCompltdOpsExposureAmount ===""))
                    
                        //     if(filterResult.length >0){
                        //         arrayFlag.push(filterResult.length);
                        //     }
                        //     if(arrayFlag.length>0){
                        //         disabledNext(true);
                        //     }else{
                        //         disabledNext(false);
                        //     }
                        // }else{

                        // subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                        //     let splitName = locationLoopItem?.locationDisplayName?.split(":");
                        //     locationLoopItem.locationDisplayName = locationLoopItem?.locationDisplayName;
                        //     if(payrollButtonCLickedFlag === "Start Payroll" && !draftmsg){
                        //         locationLoopItem.auditedExposureAmount = ""
                        //         locationLoopItem.auditedProdsCompltdOpsExposureAmount = "";
                        //     }

                        //     // setdisabledNext(true);
                            
                        // })
                    // }

                    })
                      
                })

                
                if (Object.keys(payrollData).length !== 0) {
                    const arrayFlag = [];

                    payrollData?.gl7States?.map((stateLoopItem, index) => {
                        stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {
                            const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => (item.auditedExposureAmount === undefined || item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === undefined || item.auditedProdsCompltdOpsExposureAmount === ""))

                            if (filterResult.length > 0) {
                                arrayFlag.push(filterResult.length);
                            }

                        })

                    })

                    if (arrayFlag.length > 0) {
                        setdisabledNext(true);
                    } else {
                        setdisabledNext(false);
                    }
                }
                
            }).finally(()=>{setIsLoading(false)})
        }
        else{
            PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{

                setPayrollData(res);
                CheckforPremption(res);
                setFinalpayrollData(res)
                // res?.gl7States?.map((stateLoopItem,index)=>{
                //     stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                //         subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                //             let splitName = locationLoopItem?.locationDisplayName?.split(":");
                //             locationLoopItem.locationDisplayName = locationLoopItem?.locationDisplayName;
                //             if(payrollButtonCLickedFlag === "Start Payroll" && !draftmsg){
                //                 locationLoopItem.auditedExposureAmount = 0
                //                 locationLoopItem.auditedProdsCompltdOpsExposureAmount = 0;
                //             }
                //         })

                //     })
                      
                // })                
                if (Object.keys(payrollData).length !== 0) {
                    const arrayFlag = [];

                    payrollData?.gl7States?.map((stateLoopItem, index) => {
                        stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {
                            const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => (item.auditedExposureAmount === undefined || item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === undefined || item.auditedProdsCompltdOpsExposureAmount === ""))

                            if (filterResult.length > 0) {
                                arrayFlag.push(filterResult.length);
                            }

                        })

                    })

                    if (arrayFlag.length > 0) {
                        setdisabledNext(true);
                    } else {
                        setdisabledNext(false);
                    }
                }
                
            }).finally(()=>{setIsLoading(false)})
            // PayrollService.getInProgressReportPeriod(state.jobNumber,authHeader).then((res)=>{setPayrollData(res);}).finally(()=>{setIsLoading(false)})
            
           
        }
        
    },[CheckforPremption, appValue, authHeader, setFinalpayrollData, state.jobNumber, setPayrollData])


    useEffect(()=>{
        setIsLoading(true)
        getInProgressReportPeriod();
        
        //  setFormattedPayrollData(payrollData);
        //       setFinalpayrollData(payrollData);
    },[getInProgressReportPeriod, refresh])

    

    // useEffect(()=>{

    // },[stateEmployeeTotal,stateGrossPayTotal,longshoreAndHarborEmployeeTotal,longshoreAndHarborEmployeeTotal,admiraltyLawEmployeeTotal,admiraltyLawGrossPayTotal,FELAEmployeeTotal,FELAGrossPayTotal])


    

    const setFormattedPayrollData=useCallback((payroll)=>{

       
        // const  result = payroll.coveredEmployees.reduce((r, a) => {
        //     r[a.location.address.state] = r[a.location.address.state] || [];
        //     r[a.location.address.state].push(a);
        //     return r;
        // }, Object.create(null));
        // const tempStates=[];
        // for (const [key, value] of Object.entries(result)) {
        //     tempStates.push({
        //         stateCode:key,
        //         coveredEmployees:value
        //     })
        // }
        // payroll.states=tempStates;
        // setPayrollData(payroll);
    },[])

    
    const getStates=useCallback((statecode)=>{
       
        // if(statecode!==undefined && statecode!==' ' && viewModelService!==undefined){
        //     const typeList = viewModelService.create(
        //         {},
        //         'pc',
        //         'edge.capabilities.address.dto.AddressDTO'
        //     );
        //     const availableStates = typeList.state.aspects.availableValues
        //     const statename = availableStates.filter((s)=>{return s.code===statecode})
        //         .map((s)=>{return s.name})
        //     const res = translator({
        //         id:statename[0],
        //         defaultMessage:statename[0]
        //     })
        //     return  res; 
        // }
        // return ' '
        
    },[translator, viewModelService])

    const setUpdatedPayrollData=useCallback((id,updatedCoveredEmployees)=>{
        // id = id.split(/(\d+)/)
        // _.set(payrollData,`states[${id[1]}].coveredEmployees`,updatedCoveredEmployees)
        // setPayrollData(payrollData)
        // setFinalpayrollData(payrollData)

        payrollData.gl7States.forEach((states)=>{
            // eslint-disable-next-line consistent-return
            states.subLinePresenters.forEach((emp)=>{
                // eslint-disable-next-line consistent-return
                emp.gl7PayrollLocation.forEach((glclocatin)=>{
                    if(glclocatin.auditedExposureAmount>payrollData.totalEstimatedPayrollThreshold || glclocatin.auditedProdsCompltdOpsExposureAmount>payrollData.totalEstimatedPayrollThreshold){
                        setwarningmsg(true)
                        
                        return null;
                    }
    
                    setwarningmsg(false)
                })
                
                    
            })
        })
        // setblankValues(false)
        // setrandomNumber(Math.random()*10)
        

    },[payrollData])

    

    const getPayrollData=useCallback(()=>{
        // if(appValue==='PE'){
        //     const states = payrollData.states
        //     return states
        // }
        // return payrollData.states;
        
        
    },[appValue, payrollData.states])

    const handleRefresh = useCallback(()=>{
        // if(payrollButtonCLickedFlag === "Start Payroll"){
        //     setwarningmsg(false);
        //     payrollData?.gl7States?.map((stateLoopItem,index)=>{
        //         stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
        //             subLimeLoopItem?.gl7PayrollLocation?.map((locLoppId)=>{
        //                 // eslint-disable-next-line no-param-reassign
        //                 locLoppId.auditedExposureAmount =""
                        
        //                 // eslint-disable-next-line no-param-reassign
        //                 locLoppId.auditedProdsCompltdOpsExposureAmount =""
        //             })
        //         })
        //     })
        // }        
        // refreshData();
        // setdisabledNext(true);
        setRefresh(Math.random()*10)

    },[])

    const handleChangetoZero = useCallback(()=>{
        // setblankValues(true)
        // setrandomNumber(Math.random()*10)
        console.log(payrollData);
        payrollData?.gl7States?.map((stateLoopItem,index)=>{
            stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                subLimeLoopItem?.gl7PayrollLocation?.map((locLoppId)=>{
                    // eslint-disable-next-line no-param-reassign
                    locLoppId.auditedExposureAmount =locLoppId.auditedExposureAmount>0?locLoppId.auditedExposureAmount:"0"
                    // eslint-disable-next-line no-param-reassign
                    locLoppId.auditedProdsCompltdOpsExposureAmount =locLoppId.auditedProdsCompltdOpsExposureAmount>0?locLoppId.auditedProdsCompltdOpsExposureAmount:"0"
                })
            })
        })
        setdisabledNext(false);
        setChangeValuesZero(true);
        refreshData();
    },[payrollData, refreshData])

    const premisesOperationExposureFunct = useCallback((value, path) => {
        _.set(payrollData, path, value);
        setPayrollData(payrollData);

        if (changeValuesZero === true) {
            const arrayFlag = [];

            payrollData?.gl7States?.map((stateLoopItem, index) => {
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {
                    const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => (item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === "") || (item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === ""))
                    if (filterResult.length > 0) {
                        arrayFlag.push(filterResult.length);
                    }

                })

            })
            if (arrayFlag.length > 0) {
                setdisabledNext(true);
            } else {
                setdisabledNext(false);
            }
        } else {

            const arrayFlag = [];

            payrollData?.gl7States?.map((stateLoopItem, index) => {
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {
                    // const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item) => (item.auditedExposureAmount === "" || item.auditedProdsCompltdOpsExposureAmount === ""))
                    subLimeLoopItem?.gl7PayrollLocation?.map((itrator)=>{
                        const isCompositeItem = !(itrator.exposureId > 0) && subLimeLoopItem.subLineName === "Premises/Operations and Products/Completed Operations";
                        if (isCompositeItem) {
                            if (itrator.auditedExposureAmount === undefined || itrator.auditedExposureAmount === "") {
                                arrayFlag.push(itrator);
                            }
                        } else {
                            if(itrator.auditedExposureAmount === undefined || itrator.auditedExposureAmount === "" || ((itrator.auditedProdsCompltdOpsExposureAmount === undefined || itrator.auditedProdsCompltdOpsExposureAmount === "") && subLimeLoopItem.subLineName === "Premises/Operations and Products/Completed Operations")){
                                arrayFlag.push(itrator);
                            }
                            if((itrator.auditedExposureAmount === undefined || itrator.auditedExposureAmount === "") && subLimeLoopItem.subLineName !== "Premises/Operations and Products/Completed Operations"){
                                arrayFlag.push(itrator);
                            }
                        }
                    })

                })

            })

            if (arrayFlag.length > 0) {
                setdisabledNext(true);
            } else {
                setdisabledNext(false);
            }

        }

        setPremisesOperationExposure('');
        setPremisesOperationExposure(value)
        setUpdatedPayrollData();
    }, [changeValuesZero, payrollData, setUpdatedPayrollData])

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        // var val = Math.round(Number(value) * 100) / 100;

        // var parts = val.toFixed(2).split(".");

        // var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // return num
    }

    const productsCompletedOperationsExposureFunct = useCallback((value,path)=>{
        _.set(payrollData,path, value);
        setPayrollData(payrollData);
        if(changeValuesZero === true){
            const arrayFlag = [];
            payrollData?.gl7States?.map((stateLoopItem,index)=>{
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                    const filterResult = subLimeLoopItem?.gl7PayrollLocation?.filter((item)=>(item.auditedProdsCompltdOpsExposureAmount ==="" || item.auditedExposureAmount ==="")|| (item.auditedProdsCompltdOpsExposureAmount ==="" && item.auditedExposureAmount ===""))
                    if(filterResult.length >0){
                        arrayFlag.push(filterResult.length);
                    }
                })
                
            })
            console.log(payrollData);
            
            if(arrayFlag.length>0){
                setdisabledNext(true);
            }else{
                setdisabledNext(false);
            }
        }else {

            const arrayFlag = [];

            payrollData?.gl7States?.map((stateLoopItem, index) => {
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem, indexSubLime) => {                   
                    subLimeLoopItem?.gl7PayrollLocation?.map((itrator)=>{
                        if((itrator.auditedExposureAmount === undefined || itrator.auditedExposureAmount === "" || itrator.auditedProdsCompltdOpsExposureAmount === undefined || itrator.auditedProdsCompltdOpsExposureAmount === "") && (subLimeLoopItem.subLineName === "Premises/Operations and Products/Completed Operations")){
                            arrayFlag.push(itrator);
                        }
                        if(itrator.auditedExposureAmount === "" && subLimeLoopItem.subLineName !== "Premises/Operations and Products/Completed Operations"){
                            arrayFlag.push(itrator);
                        }
                    })

                })

            })

            if (arrayFlag.length > 0) {
                setdisabledNext(true);
            } else {
                setdisabledNext(false);
            }

        }
        setProductsCompletedOperationsExposure('');
        setProductsCompletedOperationsExposure(value);
    },[changeValuesZero, payrollData])

    const autoPopulateProductsExposure = useCallback((contentItem, exposurePath, productsPath) => {
        if (!contentItem.canEditAudProductsCptOpsExp) {
            return;
        }

        const premisesValue = _.get(payrollData, exposurePath);

        if (isBlank(premisesValue)) {
            return;
        }

        if (!isBlank(_.get(payrollData, productsPath))) {
            return;
        }

        productsCompletedOperationsExposureFunct(premisesValue, productsPath);
    },[payrollData, productsCompletedOperationsExposureFunct])

    // const writeValue = useCallback(
    //     (value, path) => {
           
    //         setPremisesOperationExposure(value)
    //     },
    //     []
    // );

    const renderclassCodeContent=useCallback((loopItem,subLoopItem,pathMain)=>{
        const subLineText = loopItem.subLinePresenters.filter((subItem) => subItem.subLineName === "Premises/Operations and Products/Completed Operations")

        // if(subLineText?.length>0){
            if(subLoopItem.subLineName ==="Premises/Operations and Products/Completed Operations"){
// payrollData?.gl7States?.map((stateLoopItem,index)=>{
            // stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                return subLoopItem?.locationGroup.map((locationLoopItem,indexLocation)=>{
                    return locationLoopItem?.map((contentItem,indexc)=>{
 
                    
                        let exposureAmountPath = `${pathMain}.locationGroup[${indexLocation}][${indexc}].auditedExposureAmount`
             let productsCompletedOperationsExposurePath = `${pathMain}.locationGroup[${indexLocation}][${indexc}].auditedProdsCompltdOpsExposureAmount`
             // let locationNameSplit = contentItem.locationDisplayName.split(":");
             var expAmount = contentItem.auditedExposureAmount === 0 && payrollButtonCLickedFlag !== "Start Payroll" ? "0" : contentItem.auditedExposureAmount
             var auditedProdsCompltdOpsExposureAmount = contentItem.auditedProdsCompltdOpsExposureAmount === 0 && payrollButtonCLickedFlag !== "Start Payroll"  ? "0" : contentItem.auditedProdsCompltdOpsExposureAmount
             return (<div><div className={subLoopItem.subLineName ==="Premises/Operations and Products/Completed Operations"?styles.cardBodyContentClass:styles.cardBodyContentClass5Cols}>
                 
                 <div className={styles.commonClassGridContent}>{contentItem.locationDisplayName}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.premiumBasis}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.classCode}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.classDescription}</div>
                 {
                 <><div className={styles.commonClassGridContentBox}>
                         <div style={{ display: "Grid", gridTemplateColumns: '0.1fr auto' }}>
                             <div className={styles.dollerClassPremises}>$</div>
                             <div>
                                 <InputNumberField
                                     path={exposureAmountPath}
                                     id="hjj"
                                     type="field"
                                     decimalPlaces={0}
                                     onValueChange={(value) => premisesOperationExposureFunct(value, exposureAmountPath)}
                                     onBlur={() => autoPopulateProductsExposure(contentItem, exposureAmountPath, productsCompletedOperationsExposurePath)}
                                     hideLabel
                                     value={expAmount}
                                     className={styles.alignTextBoxNumber} />
                                      
                             </div>
                         </div>
                     </div>                     
                         <>{contentItem.canEditAudProductsCptOpsExp ?
                            <>
                            <div className={styles.commonClassGridContentBox}>
                             <div style={{ display: "Grid", gridTemplateColumns: '0.2fr auto' }}>
                                 <div className={styles.dollerClass}>$</div>
                                 <div>
                                     <InputNumberField
                                         path={productsCompletedOperationsExposurePath}                                        
                                         id="klk"
                                         type="field"
                                         decimalPlaces={0}
                                         onValueChange={(value) => productsCompletedOperationsExposureFunct(value, productsCompletedOperationsExposurePath)}
                                         type="field"
                                         value={auditedProdsCompltdOpsExposureAmount}
                                         hideLabel
                                         className={styles.alignTextBoxNumber} />
                                 </div>
                             </div>
                         </div>
                            </>
                        :<div className={styles.commonClassGridContentBox}></div>
                    }                        
                 </>
             </>
                 
         }
         
                 </div>
                 <div>
                { indexc ===locationLoopItem.length-1 &&
                 <><hr></hr>
                    <div className={styles.cardBodyContentClassLocationTotal}>
                        <div></div>
                        <div></div>
                        <div></div>
                             <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>Location Total</div>
                             <div style={{ 'textAlign': "right", marginLeft:"26px",fontSize: '1rem', fontWeight: 'bold', backgroundColor: '#78787878', border: '1px solid #78787878',paddingRight:'10px' }}>$ {isNaN(locationLoopItem.locationExposureTotal) === true?0:getFormatAmt(parseInt(locationLoopItem.locationExposureTotal)) || 0}</div>
                             <div style={{ 'textAlign': "right", paddingRight:'10px', marginLeft:"29px",marginRight:"10px", fontSize: '1rem', fontWeight: 'bold', backgroundColor: '#78787878', border: '1px solid #78787878' }}>$ {isNaN(locationLoopItem.locationTotalCompletedTotal) === true?0:getFormatAmt(parseInt(locationLoopItem.locationTotalCompletedTotal)) || 0}</div>
                    </div>
                <hr></hr></>
             
                }
                 </div>
             </div>
             )
                     })
                 })
        }else{

            // payrollData?.gl7States?.map((stateLoopItem,index)=>{
            // stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                return subLoopItem?.locationGroup.map((locationLoopItem,indexLocation)=>{
                    return locationLoopItem?.map((contentItem,indexc)=>{
 
                    
                         let exposureAmountPath = `${pathMain}.locationGroup[${indexLocation}][${indexc}].auditedExposureAmount`
             let productsCompletedOperationsExposurePath = `${pathMain}.locationGroup[${indexLocation}][${indexc}].auditedProdsCompltdOpsExposureAmount`
             // let locationNameSplit = contentItem.locationDisplayName.split(":");
             var expAmount = contentItem.auditedExposureAmount === 0 && payrollButtonCLickedFlag !== "Start Payroll"  ? "0" : contentItem.auditedExposureAmount
             return (<div><div className={styles.cardBodyContentClass5Cols}>
                 
                 <div className={styles.commonClassGridContent}>{contentItem.locationDisplayName}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.premiumBasis}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.classCode}</div>
                 <div className={styles.commonClassGridContent}>{contentItem.classDescription}</div>
                 <><div className={styles.commonClassGridContentBox}>
                         <div style={{ display: "Grid", gridTemplateColumns: '0.2fr auto' }}>
                             <div className={styles.dollerClass}>$</div>
                             <div>
                                 <InputNumberField
                                     path={exposureAmountPath}
                                     type="field"
                                     id="hjj"
                                     type="field"
                                     decimalPlaces={0}
                                     onValueChange={(value) => premisesOperationExposureFunct(value, exposureAmountPath)}
                                     hideLabel
                                     placeholder=""
                                     value={expAmount}
                                     className={styles.alignTextBoxNumber} />
                             </div>
                         </div>
                     </div></> 
                 </div>
                 <div>
                 
             {indexc ===locationLoopItem.length-1 && 
             <><hr></hr><div className={styles.totalsBottomClassCls}>
                             <div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Location Total</div>
                             <div style={{ 'textAlign': "right", marginRight: '6px',marginRight: '13px', fontSize: '1rem', fontWeight: 'bold', backgroundColor: '#78787878', border: '1px solid #78787878',paddingRight:'10px' }}>$ {isNaN(locationLoopItem.locationExposureTotal) === true?0: getFormatAmt(parseInt(locationLoopItem.locationExposureTotal)) || 0}</div>
                         </div><hr></hr></>    
             }
                 </div>
             </div>
             )
                     })
                 })
        }
         
        
    },[payrollButtonCLickedFlag, premisesOperationExposureFunct, productsCompletedOperationsExposureFunct, autoPopulateProductsExposure])

    const renderClassCodeTableHeader = useCallback((loopItem,indexV,pathV)=>{
        const subLineText = loopItem.subLinePresenters.filter((subItem) => subItem.subLineName === "Premises/Operations and Products/Completed Operations")
        if(subLineText?.length>0){
            // eslint-disable-next-line array-callback-return
            return loopItem?.subLinePresenters.map((subLoopItem,index)=>{
                // console.log(pathV,"pathV");
                let pathSub =  `${pathV}.subLinePresenters[${index}]` 
                // console.log(pathSub,"pathSub");
                return subLoopItem.gl7PayrollLocation.length > 0 && <div>
                    <div className={styles.sublineClas}>{subLoopItem.subLineName}</div>
                    <div className={subLoopItem.subLineName ==="Premises/Operations and Products/Completed Operations"?styles.cardBodyCalss:styles.cardBodyCalss5Cols}>
                        <div className={styles.commonClassGrid}>Location Name</div>
                        <div className={styles.commonClassGrid}>Premium Basis</div>
                        <div className={styles.commonClassGrid}>Class Code</div>
                        <div className={styles.commonClassGrid}>Class Code Description</div>
                        <>{subLoopItem.subLineName ==="Premises/Operations and Products/Completed Operations"?
                            <><div className={styles.commonClassGridExposure}>Premises/Operation Exposure</div><div className={styles.commonClassGridProductExp}>Products/Completed Operations Exposure</div></>
                        :<div className={styles.commonClassGridProductExp}>Exposure</div>
                    }
                        
                        </>
                        
                    </div>
                    {renderclassCodeContent(loopItem,subLoopItem,pathSub)}
                </div>
            })
        }else{
           // eslint-disable-next-line array-callback-return
           return loopItem?.subLinePresenters.map((subLoopItem,index)=>{
            // console.log(pathV,"pathV");
            let pathSub =  `${pathV}.subLinePresenters[${index}]` 
            // console.log(pathSub,"pathSub");
            return subLoopItem.gl7PayrollLocation.length > 0 && <div>
                <div className={styles.sublineClas}>{subLoopItem.subLineName}</div>
                <div className={styles.cardBodyCalss5Cols}>
                    <div className={styles.commonClassGrid}>Location Name</div>
                    <div className={styles.commonClassGrid}>Premium Basis</div>
                    <div className={styles.commonClassGrid}>Class Code</div>
                    <div className={styles.commonClassGrid}>Class Code Description</div>
                     <div className={styles.commonClassGridExposureAmt}>Exposure</div>
                </div>
                {renderclassCodeContent(loopItem,subLoopItem,pathSub)}
            </div>
        }) 
        }
        
    },[renderclassCodeContent])

    const renderCompositeTable = useCallback((loopItem, pathV) => {
        // Group composite items (exposureId falsy) by subline for the sub-header display
        const sublinesWithComposite = [];
        loopItem?.subLinePresenters?.forEach((sub, subIdx) => {
            const subItems = [];
            sub?.gl7PayrollLocation?.forEach((loc, locIdx) => {
                if (!loc.exposureId) {
                    subItems.push({
                        loc,
                        path: `${pathV}.subLinePresenters[${subIdx}].gl7PayrollLocation[${locIdx}].auditedExposureAmount`
                    });
                }
            });
            if (subItems.length > 0) {
                sublinesWithComposite.push({ subLineName: sub.subLineName, items: subItems });
            }
        });

        if (!sublinesWithComposite.length) return null;

        const totalExposure = sublinesWithComposite.reduce((sum, { items }) =>
            sum + items.reduce((s, { loc }) => s + (parseInt(loc.auditedExposureAmount, 10) || 0), 0), 0
        );

        return (
            <div>
                <div className={styles.stateFontClass}>
                    {translator(messages.compositeRateEndorsement)}
                </div>
                {sublinesWithComposite.map(({ subLineName, items }, subIdx) => (
                    <div key={subIdx}>
                        <div className={styles.sublineClas}>{subLineName}</div>
                        <div className={styles.cardBodyCalssComposite}>
                            <div className={styles.commonClassGrid}>{translator(messages.compositeScheduleNumber)}</div>
                            <div className={styles.commonClassGrid}>{translator(messages.compositePremiumBasis)}</div>
                            <div className={styles.commonClassGrid}>{translator(messages.compositeClass)}</div>
                            <div className={styles.commonClassGridExposureAmt}>{translator(messages.compositeExposure)}</div>
                        </div>
                        {items.map(({ loc, path }, idx) => (
                            <div key={idx} className={styles.cardBodyContentClassComposite}>
                                <div className={styles.commonClassGridContent}>{loc.locationDisplayName}</div>
                                <div className={styles.commonClassGridContent}>{loc.premiumBasis}</div>
                                <div className={styles.commonClassGridContent}>{loc.classCode}</div>
                                <div className={styles.commonClassGridContentBox}>
                                    <div style={{ display: 'Grid', gridTemplateColumns: '0.2fr auto' }}>
                                        <div className={styles.dollerClass}>$</div>
                                        <div>
                                            <InputNumberField
                                                path={path}
                                                id={`composite-exp-${subIdx}-${idx}`}
                                                type="field"
                                                decimalPlaces={0}
                                                onValueChange={(value) => premisesOperationExposureFunct(value, path)}
                                                hideLabel
                                                value={loc.auditedExposureAmount === 0 && payrollButtonCLickedFlag !== 'Start Payroll' ? '0' : loc.auditedExposureAmount}
                                                className={styles.alignTextBoxNumber}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                <hr />
                <div className={styles.totalsBottomClassComposite}>
                    <div></div>
                    <div></div>
                    <div style={{ textAlign: 'right', fontSize: '1rem', fontWeight: 'bold', paddingTop: '6px' }}>
                        {translator(messages.compositeTotalExposure)}
                    </div>
                    {/* GCD-2452: removed grey box (backgroundColor/border) around the composite Total
                        Exposure per Branden's 6/4 UAT feedback; align value padding (10px) with the
                        Exposure input cells above so the numbers line up like the WC report. */}
                    <div className={styles.commonClassGridContentBox}>
                        <div style={{ display: 'Grid', gridTemplateColumns: '0.2fr auto' }}>
                            <div className={styles.dollerClass} style={{ fontWeight: 'bold' }}>$</div>
                            <div className={styles.alignTextBoxNumber} style={{ fontWeight: 'bold', paddingRight: '10px' }}>
                                {getFormatAmt(totalExposure)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [getFormatAmt, payrollButtonCLickedFlag, premisesOperationExposureFunct, translator])

    const rederFinalPremesisBaseis = useCallback((prem) =>{
        if(prem.exposureTotalAmt > 0 || prem.ProductsCompletedOperationTotalAmt > 0){
            return <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem'}}>Jurisdiction Total ({prem.premiumBasis})</div>
        <div style={{ 'textAlign': "right", fontSize: '1rem', marginRight:'30px' }}>{prem.exposureTotalAmt !==0 && '$ ' + getFormatAmt(prem.exposureTotalAmt)} </div> 
        <div style={{ 'textAlign': "right", marginRight: '15px', fontSize: '1rem' }}>{prem.ProductsCompletedOperationTotalAmt !==0 && '$ ' + getFormatAmt(prem.ProductsCompletedOperationTotalAmt)}</div></>
        } else{
            return <></>
        }
    
      },[])

    const renderAllStateTotals =useCallback(()=>{
        if(Object.keys(payrollData).length !== 0){
        // eslint-disable-next-line @typescript-eslint/no-shadow
        // let subLineText1;
        const arrayGL1 = [];
        // payrollData?.gl7States?.map((loopItem,index)=>{
        //     subLineText= loopItem.subLinePresenters.filter((subItem) => subItem.subLineName === "Premises/Operations and Products/Completed Operations")
        //  })
        payrollData?.gl7States?.map((loopItem,index)=>{
            loopItem.subLinePresenters?.map((subLineText)=>{
                if(subLineText.subLineName === "Premises/Operations and Products/Completed Operations"){
                    arrayGL1.push(subLineText);
                }
            })
            
         })
       
        //  arrayGL1.push(subLineText1);
        if(arrayGL1?.length >0 && arrayGL1.includes(undefined) !==true){
       return <div className={styles.totalsBottomClass}>
         {payrollData.finaPremiumBasisDetails.map((prem)=>{
            return rederFinalPremesisBaseis(prem)
        })}     
        {(payrollData.juridicationOperatingvExpensesExposure > 0 || payrollData.juridicationProductsCompletedOperationOperatingvExpenses > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Jurisdiction Total (Total Operating Expenses)</div><div style={{ 'textAlign': "right", fontSize: '1rem', marginRight:'30px', fontWeight: 'bold' }}>{payrollData.juridicationOperatingvExpensesExposure !==0 && '$ ' + getFormatAmt(payrollData.juridicationOperatingvExpensesExposure)}</div><div style={{ 'textAlign': "right", marginRight: '15px', fontSize: '1rem', fontWeight: 'bold' }}>{payrollData.juridicationProductsCompletedOperationOperatingvExpenses !==0 && '$ ' + getFormatAmt(payrollData.juridicationProductsCompletedOperationOperatingvExpenses)}</div></>}
        {(payrollData.payrollPeriodExposureTotal > 0 || payrollData.payrollPeriodProductsCompletedOperationTotal > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Payroll Period Total</div>
        <div style={{ 'textAlign': "right", fontSize: '1rem',  marginRight:'30px',fontWeight: 'bold' }}>
            {payrollData.payrollPeriodExposureTotal !==0 && '$ ' + getFormatAmt(payrollData.payrollPeriodExposureTotal)}</div>
            <div style={{ 'textAlign': "right", marginRight: '15px', fontSize: '1rem', fontWeight: 'bold' }}>{payrollData.payrollPeriodProductsCompletedOperationTotal !==0 && '$ ' + getFormatAmt(payrollData.payrollPeriodProductsCompletedOperationTotal)}</div></>}
        </div> 
        }else{  
            return <div className={styles.totalClassB}>
                {(payrollData.juridicationExposureGrossSales > 0) && <>
                    <div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Jurisdiction Total (Gross Sales)</div>
                    <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>{payrollData.juridicationExposureGrossSales !== 0 && '$ ' + getFormatAmt(payrollData.juridicationExposureGrossSales)}
                    </div> 
                    </>}
                {(payrollData.juridicationOperatingvExpensesExposure > 0) && <>
                <div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Jurisdiction Total (Total Operating Expenses)</div>
                <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>{payrollData.juridicationOperatingvExpensesExposure !== 0 && '$ ' + getFormatAmt(payrollData.juridicationOperatingvExpensesExposure)}</div></>}
                {(payrollData.payrollPeriodExposureTotal > 0) && <>
                <div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>Payroll Period Total</div>
                <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>{payrollData.payrollPeriodExposureTotal !== 0 && '$ ' + getFormatAmt(payrollData.payrollPeriodExposureTotal)}</div>

                </>}
            </div>
        }
        }
    
    },[payrollData])

    const rederPremesisBaseis = useCallback((subLineText,loopItem,prem) =>{
      //  return <div>this testtt</div>
        //loopItem.premiumBasisDetails.map((preBas,index)=>{            
            return <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>{loopItem.jurisdicationName} Jurisdiction Total ({prem.premiumBasis})</div>
          <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold',marginRight:'44px' }}>$ {getFormatAmt(prem.exposureTotalAmt)} </div> 
          {(subLineText.length > 0) ?  <div style={{ 'textAlign': "right", marginRight: '24px', fontSize: '1rem', fontWeight: 'bold' }}>{subLineText.length >0 && '$ ' + getFormatAmt(prem.ProductsCompletedOperationTotalAmt)}</div>: <></>}</>
        //})
    },[])
   
    // console.log(payrollData);
    const renderMainTable = useCallback(()=>{
        
        if(Object.keys(payrollData).length !== 0){
            console.log(payrollData)
            // let groupedDrivers;
            payrollData?.gl7States?.map((stateLoopItem,index)=>{
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                    // subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                        
                    // })
                    subLimeLoopItem.locationGroup = _.groupBy(subLimeLoopItem?.gl7PayrollLocation, (groupItem) => {
                        return groupItem.locationDisplayName;
                    })
                    subLimeLoopItem.locationGroup = Object.values(subLimeLoopItem.locationGroup);

                })
                  
            })

            payrollData?.gl7States?.map((stateLoopItem,index)=>{
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                    subLimeLoopItem?.locationGroup.map((locationLoopItem,indexLocation)=>{
                        locationLoopItem.locationExposureTotal = 0
                        locationLoopItem.locationTotalCompletedTotal = 0
                        locationLoopItem.map((inLoop)=>{
                            locationLoopItem.locationExposureTotal += parseInt(inLoop.auditedExposureAmount)
                            locationLoopItem.locationTotalCompletedTotal += parseInt(inLoop.auditedProdsCompltdOpsExposureAmount)
                        })
                    }) 

                })
                  
            })
            
            let juridicationExposureGrossSales = 0;
            let juridicationProductsCompletedOperationGrossSalesTotal = 0;
            let finaPremiumBasisDetails = []

            let juridicationOperatingvExpensesExposure = 0;
            let juridicationProductsCompletedOperationOperatingvExpenses = 0;

            //payroll period Totals
                
                let payrollPeriodExposureTotal =0
                let payrollPeriodProductsCompletedOperationTotal =0

            //Totals calculation
            payrollData?.gl7States?.map((stateLoopItem,index)=>{
                //gross sales
                // eslint-disable-next-line no-param-reassign
                stateLoopItem.premiumBasisDetails = []                
                stateLoopItem.exposureGrossSalesTotal = 0;
                // eslint-disable-next-line no-param-reassign
                stateLoopItem.ProductsCompletedOperationGrossSalesTotal = 0;

                //OperatingvExpenses Exposure
                // eslint-disable-next-line no-param-reassign
                stateLoopItem.totalOperatingExpensesExposureTotal = 0;
                // eslint-disable-next-line no-param-reassign
                stateLoopItem.totalOperatingExpensesCompletedTotal = 0;

                // eslint-disable-next-line no-param-reassign
                stateLoopItem.stateTotalExposures = 0;
                // eslint-disable-next-line no-param-reassign
                stateLoopItem.stateTotalProductsCompletedOperation = 0;

                

                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{
                    // eslint-disable-next-line no-param-reassign
                    subLimeLoopItem.locationExposureTotal=0
                    // eslint-disable-next-line no-param-reassign
                    subLimeLoopItem.locationProductsCompletedOperationTotal=0
                    

                    subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{
                    //    let locatinSplit = locationLoopItem.locationDisplayName.split(":");
                        // eslint-disable-next-line no-param-reassign
                        subLimeLoopItem.locationExposureTotal += parseInt(locationLoopItem.auditedExposureAmount) || 0
                        payrollPeriodExposureTotal +=parseInt(locationLoopItem.auditedExposureAmount) || 0
                        // eslint-disable-next-line no-param-reassign
                        subLimeLoopItem.locationProductsCompletedOperationTotal += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                        payrollPeriodProductsCompletedOperationTotal +=parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                        // eslint-disable-next-line no-param-reassign
                        stateLoopItem.stateTotalExposures += parseInt(locationLoopItem.auditedExposureAmount) || 0
                        // eslint-disable-next-line no-param-reassign
                        stateLoopItem.stateTotalProductsCompletedOperation += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0                        
                        var premiumBasIndex = stateLoopItem.premiumBasisDetails.findIndex((itm)=>itm.premiumBasis ===locationLoopItem.premiumBasis)
                            if(premiumBasIndex === -1){
                                var premObj = {}
                                premObj.premiumBasis = locationLoopItem.premiumBasis
                                premObj.exposureTotalAmt = 0
                                premObj.ProductsCompletedOperationTotalAmt = 0
                                premObj.exposureTotalAmt += parseInt(locationLoopItem.auditedExposureAmount) || 0
                                premObj.ProductsCompletedOperationTotalAmt += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                                stateLoopItem.premiumBasisDetails.push(premObj)                                
                            }else{
                                stateLoopItem.premiumBasisDetails[premiumBasIndex].exposureTotalAmt += parseInt(locationLoopItem.auditedExposureAmount) || 0
                                stateLoopItem.premiumBasisDetails[premiumBasIndex].ProductsCompletedOperationTotalAmt += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                            }
                        
                        var premiumBasIndex = finaPremiumBasisDetails.findIndex((itm)=>itm.premiumBasis ===locationLoopItem.premiumBasis)
                        if(premiumBasIndex === -1){
                            var premObj = {}
                            premObj.premiumBasis = locationLoopItem.premiumBasis
                            premObj.exposureTotalAmt = 0
                            premObj.ProductsCompletedOperationTotalAmt = 0
                            premObj.exposureTotalAmt += parseInt(locationLoopItem.auditedExposureAmount) || 0
                            premObj.ProductsCompletedOperationTotalAmt += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                            finaPremiumBasisDetails.push(premObj)                            
                        }else{
                            finaPremiumBasisDetails[premiumBasIndex].exposureTotalAmt += parseInt(locationLoopItem.auditedExposureAmount) || 0
                            finaPremiumBasisDetails[premiumBasIndex].ProductsCompletedOperationTotalAmt += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                        }

                        if(locationLoopItem.premiumBasis ==="Gross Sales"){                            
                            stateLoopItem.exposureGrossSalesTotal += parseInt(locationLoopItem.auditedExposureAmount) || 0
                            stateLoopItem.ProductsCompletedOperationGrossSalesTotal += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0

                            juridicationExposureGrossSales += parseInt(locationLoopItem.auditedExposureAmount) || 0
                            juridicationProductsCompletedOperationGrossSalesTotal += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0

                            

                        }if(locationLoopItem.premiumBasis ==="Total Operating Expenses"){
                            stateLoopItem.totalOperatingExpensesExposureTotal += parseInt(locationLoopItem.auditedExposureAmount) || 0
                            stateLoopItem.totalOperatingExpensesCompletedTotal += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0

                             juridicationOperatingvExpensesExposure += parseInt(locationLoopItem.auditedExposureAmount) || 0
                             juridicationProductsCompletedOperationOperatingvExpenses += parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount) || 0
                        }
                        
                    })

                })
                        
             })
             //Final Total Calculations
             payrollData.juridicationExposureGrossSales = juridicationExposureGrossSales;
             payrollData.juridicationProductsCompletedOperationGrossSalesTotal = juridicationProductsCompletedOperationGrossSalesTotal || 0
             payrollData.juridicationOperatingvExpensesExposure =juridicationOperatingvExpensesExposure || 0
             payrollData.juridicationProductsCompletedOperationOperatingvExpenses = juridicationProductsCompletedOperationOperatingvExpenses || 0
             payrollData.payrollPeriodExposureTotal = payrollPeriodExposureTotal;
             payrollData.payrollPeriodProductsCompletedOperationTotal = payrollPeriodProductsCompletedOperationTotal;
             payrollData.finaPremiumBasisDetails = finaPremiumBasisDetails;
            //  payrollData.payrollPeriodExposure = payrollData.juridicationExposureGrossSales + payrollData.juridicationProductsCompletedOperationGrossSalesTotal || 0
            //  payrollData.payrollPeriodProductsCompletedOperation = payrollData.juridicationProductsCompletedOperationGrossSalesTotal + payrollData.juridicationProductsCompletedOperationOperatingvExpenses || 0

          return payrollData?.gl7States?.map((loopItem,index)=>{
            const path = `gl7States[${index}]`;

            let payrollLength = 0

             subLineText = loopItem.subLinePresenters.filter((subItem) => subItem.subLineName === "Premises/Operations and Products/Completed Operations" && subItem.gl7PayrollLocation?.length > 0)
             loopItem.subLinePresenters.forEach((sp) => {
                payrollLength += sp.gl7PayrollLocation.length
            });             
              return <div style={{ paddingBottom: '30px' }}><Flex>
                  <FlexItem style={{width: '-webkit-fill-available'}}

                  >
                    {(payrollLength > 0 || payrollData.glSubPremVisible === true) &&
                      <Card
                          id="Sdsds"
                          isPanel
                          subTitle=""
                          title=""
                          className={styles.cardClassWidth}

                      >
                          <div>
                              <div className={styles.stateFontClass}>{loopItem.jurisdicationName}</div>
                              {payrollData.glSubPremVisible === true
                                  ? renderCompositeTable(loopItem, path)
                                  : <>
                                      {renderClassCodeTableHeader(loopItem, index, path)}
                                      {subLineText?.length >0?
                                    <>
                                    <div className={styles.totalsBottomClass}>
                                        {loopItem.premiumBasisDetails.map((prem)=>{
                                            return rederPremesisBaseis(subLineText,loopItem,prem)
                                        })}                                        
                                      {/* <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>{loopItem.jurisdicationName} Jurisdiction Total (Gross Sales)</div>
                                      <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold',marginRight:'44px' }}>$ {getFormatAmt(loopItem.exposureGrossSalesTotal)} </div>
                                      <div style={{ 'textAlign': "right", marginRight: '24px', fontSize: '1rem', fontWeight: 'bold' }}>{subLineText.length >0 && '$ ' + getFormatAmt(loopItem.ProductsCompletedOperationGrossSalesTotal)}</div></> */}
                                      {(loopItem.totalOperatingExpensesExposureTotal > 0 || loopItem.totalOperatingExpensesCompletedTotal > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>State Jurisdiction Total (Total Operating Expenses)</div><div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>{`$ ${getFormatAmt(loopItem.totalOperatingExpensesExposureTotal)}`}</div><div style={{ 'textAlign': "right", marginRight: '15px', fontSize: '1rem', fontWeight: 'bold' }}>{subLineText.length >0 && '$ ' + getFormatAmt(loopItem.totalOperatingExpensesCompletedTotal)}</div></>}
                                      {(loopItem.stateTotalExposures > 0 || loopItem.stateTotalProductsCompletedOperation > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}> {`${loopItem.jurisdicationName} State Total`}</div><div style={{ 'textAlign': "right", fontSize: '1rem',marginRight:'44px' ,fontWeight: 'bold' }}>$ {getFormatAmt(loopItem.stateTotalExposures)}</div><div style={{ 'textAlign': "right", marginRight: '24px', fontSize: '1rem', fontWeight: 'bold' }}>{subLineText.length >0 && '$ ' + getFormatAmt(loopItem.stateTotalProductsCompletedOperation)}</div></>}
                                  </div>
                                  
                                  </>
                                  :
                                  <div className={styles.totalsBottomClass1}>
                                    {loopItem.premiumBasisDetails.map((prem)=>{
                                            return rederPremesisBaseis(subLineText,loopItem,prem)
                                        })} 
                                      {/* <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>{loopItem.jurisdicationName} Jurisdiction Total (Gross Sales)</div>
                                      <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>$ {getFormatAmt(loopItem.exposureGrossSalesTotal)} </div>
                                      
                                      </> */}
                                      {(loopItem.totalOperatingExpensesExposureTotal > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>State Jurisdiction Total (Total Operating Expenses)</div><div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>{`$ ${getFormatAmt(loopItem.totalOperatingExpensesExposureTotal)}`}</div></>}
                                      {/* {(loopItem.stateTotalExposures > 0 || loopItem.stateTotalProductsCompletedOperation > 0) && <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}> {`${loopItem.jurisdicationName} State Totaljj`}</div><div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' }}>$ {loopItem.stateTotalExposures}</div></>} */}
                                      <><div style={{ 'textAlign': "right", marginRight: '80px', fontSize: '1rem', fontWeight: 'bold' }}>{loopItem.jurisdicationName} State Total</div>
                                      <div style={{ 'textAlign': "right", fontSize: '1rem', fontWeight: 'bold' , marginRight: '44px'}}>$ {getFormatAmt(loopItem.stateTotalExposures)} </div>
                                      
                                      </>
                                  </div>
                                      }
                                    </>
                              }
                          </div>
                      </Card>
                    }
                  </FlexItem>
              </Flex></div>
        })

        }
    },[payrollData, renderClassCodeTableHeader, rederPremesisBaseis, renderCompositeTable])

    const getsaveDraftMsg = useCallback(() =>{
        if(appValue==="PE"){
            return <>Your information has been saved! Please click<button className={styles.draftmsg} onClick={()=>{history.go(-1)}}>back</button>to go to previous screen</>
        }

        return <>Your information has been saved! Please click <Link to='/payroll-reporting/list/report'>back</Link> to go to previous screen</>
    },[appValue, history, props.location.pathname])

    const updateAuditReport=useCallback(async()=>{

        payrollData?.gl7States?.map((stateLoopItem,index)=>{
            stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{ 
                subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{  
                    // eslint-disable-next-line no-param-reassign
                    locationLoopItem.auditedExposureAmount=parseInt(locationLoopItem.auditedExposureAmount, 10)
                    // eslint-disable-next-line no-param-reassign
                    locationLoopItem.auditedProdsCompltdOpsExposureAmount=parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount, 10)
 
                   if(subLimeLoopItem.subLineName !== "Premises/Operations and Products/Completed Operations"){
                    // eslint-disable-next-line no-param-reassign
                    locationLoopItem.auditedProdsCompltdOpsExposureAmount = locationLoopItem.auditedExposureAmount;
                   } else if (!(locationLoopItem.exposureId > 0)) {
                    // eslint-disable-next-line no-param-reassign
                    locationLoopItem.auditedProdsCompltdOpsExposureAmount = 0;
                   }
                })
            })
        })
        
        if(appValue==="PE"){
            await PayrollService.PEupdateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        //title: messages.draftErrorMessage,
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessageGL)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
        else{
            await PayrollService.updateAuditReport(payrollData,authHeader)
                .then(()=>{
                    setdraftmsg(true);
                })
                .catch(()=>{
                    ModalNext.showAlert({
                        
                        title: (
                            <p className={styles.draftMsg}>
                                {translator(messages.draftErrorMessageGL)}
                            </p>
                        ),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.close
                    }).catch(_.noop);
                })
        }
    },[ModalNext, appValue, authHeader, payrollData, translator])

    const handleCancel = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.startpagecancelChangeTitleGL,
            message: messages.startpagecancelChangeMessageGL,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel
        }).then((results) => {
            if(results === 'confirm'){
                if(appValue==="PE")
                {
                    //history.push(props.location.pathname)
                    history.go(-1)
                }
                else{
                    history.go(-1)
                }
            }
        }, _.noop);
    },[ModalNext, appValue, history, props.location.pathname])

    const getreportingperioddata=useCallback(()=>{
        if(!_.isEmpty(payrollData)){
            const startDate=moment(payrollData.reportPeriodStart).format('MM/DD/YYYY')
            const endDate=moment(payrollData.reportPeriodEnd).format('MM/DD/YYYY')
            return `${startDate} - ${endDate}`
        }
        return " "
    },[payrollData])


    const handleReview =useCallback(async()=>{
        setIsLoading(true)
        
        // payrollData?.coveredEmployees?.map((item)=>{
        //     if(item?.auditedEmployeeCount===undefined){
        //         item.auditedEmployeeCount=0;
        //     }
        // })
        payrollData?.gl7States?.map((stateLoopItem,index)=>{
                stateLoopItem?.subLinePresenters?.map((subLimeLoopItem,indexSubLime)=>{ 
                    subLimeLoopItem?.gl7PayrollLocation?.map((locationLoopItem,indexLocation)=>{  
                        // eslint-disable-next-line no-param-reassign
                        locationLoopItem.auditedExposureAmount=parseInt(locationLoopItem.auditedExposureAmount, 10)
                        // eslint-disable-next-line no-param-reassign
                        locationLoopItem.auditedProdsCompltdOpsExposureAmount=parseInt(locationLoopItem.auditedProdsCompltdOpsExposureAmount, 10) 

                        if(subLimeLoopItem.subLineName !== "Premises/Operations and Products/Completed Operations"){
                            // eslint-disable-next-line no-param-reassign
                            locationLoopItem.auditedProdsCompltdOpsExposureAmount = locationLoopItem.auditedExposureAmount;
                        } else if (!(locationLoopItem.exposureId > 0)) {
                            // eslint-disable-next-line no-param-reassign
                            locationLoopItem.auditedProdsCompltdOpsExposureAmount = 0;
                        }
                    })
                })
            })

        if(appValue==="PE"){
           
            await PayrollService.PEcalculatePremiumsForReport(payrollData,authHeader).then((result)=>{  
                //setPayrollData(result);
                setreviewData(result);
                setviewStartPage(false);
                setIsLoading(false);
            })
        }
        else{
            // eslint-disable-next-line consistent-return
            await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
                setIsLoading(false)
                    return history.push({
                        pathname: `/payroll-reporting/reviewGL`,
                        state: {
                            data: result,
                            appValue:'CE' 
                        },
                    }); 
            })

            // await PayrollService.calculatePremiumsForReport(payrollData,authHeader).then((result)=>{
            //     setPayrollData(result);
            //     setreviewData(result)
            //     setviewStartPage(false)
            // })

        }
    },[appValue, authHeader, history, isLoading, payrollData])

    // const renderClassNameForClassCode=useCallback(()=>{
    //     let classNameV = '';
    //     if(appValue ==='CE'){
    //         // eslint-disable-next-line no-const-assign
    //         classNameV = "CEclassCodeClClass"
    //     } 
    //     return classNameV;
    // },[appValue])

    const handlepremitionCancelBtn=useCallback(()=>{
        // ModalNext.showConfirm({
        //     title:"Cancel payroll reporting update",
        //     message:"Are you sure you want to cancel your payroll reporting changes?",
        //     status: 'info',
        //     icon: 'mi-error-outline',
        //     confirmButtonText: commonMessages.yesModel,
        //     cancelButtonText: commonMessages.noModel,
        // }).then((results) => {
        //     if (results === 'confirm') {
        //         history.go(-1);
        //     }
        // }, _.noop);
    },[ModalNext, history])


    const generateOverrides = useMemo(() => {

       
        
    }, [appValue, getStates, payrollData,stateData,randomNumber,viewStartPage,blankValues]);
    
    const DraftDataFromReview=useCallback((res)=>{
        setPayrollData(res);
        renderMainTable();
    },[renderMainTable])

    const overrides = {
        premptionCard:{
            visible:PremptionError
        },
        pageContainer:{
            visible:viewStartPage && !PremptionError
        },
        payrollDetails:{
            data:getPayrollData(),
        },
        reportingperioddata:{
            value:getreportingperioddata()
        },
        totalempcountdata:{
            value:totalData.empCount || `0`,
            // visible:totalData.empCount !==0
        },
        totalgrossamountdata:{
            value:totalData.grossAmount || `0`,
            // visible:totalData.grossAmount !==0
        },
        // totalempcount:{
        //     visible:(totalData.empCount !==0 || totalData.grossAmount !==0)
        // },
        savedraftmsg:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },
        savedraftmsg2:{
            content:getsaveDraftMsg(),
            visible:draftmsg
        },        
        review:{
            disabled:!stateData?.every((i)=>Object.values(i).every((value)=>value>=0)) || disabledNext
        },

        bodyClassCodeTable:{
            content:renderMainTable()
        },

        allStateTotals:{
            content:renderAllStateTotals()
        },
        thersholdwaring:{
            visible: payrollData.payrollPeriodExposureTotal  > payrollData.totalGlEstThresholdExpCol || payrollData.payrollPeriodProductsCompletedOperationTotal > payrollData.totalGlEstThresholdExpColProdExpCol,  ///warningmsg//totalData.grossAmount>payrollData.totalEstimatedPayrollThreshold,
        },
        
        // finaltotalStateAct:{
        //     visible:stateEmployeeTotal !==0 && stateGrossPayTotal !==0
        // },
        // longshoreAndHarborBlock:{
        //     visible:longshoreAndHarborEmployeeTotal !==0 && longshoreAndHarborGrossPayTotal !==0
        // },
        // admiraltyLawBlock:{
        //     visible:admiraltyLawEmployeeTotal !==0 && admiraltyLawGrossPayTotal !==0
        // },
        // FELABlock:{
        //     visible:FELAEmployeeTotal !==0 && FELAGrossPayTotal !==0
        // },
        payrollreviewGL:{
            data: reviewData,
            appValue,
            visible:!viewStartPage && !_.isEmpty(reviewData)&& !PremptionError,
            onCallback:setviewStartPage,
            DraftDataFromReview
        },
        ...generateOverrides,
        // ...juridictionOverrides
    };

    
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleCancel:handleCancel,
            handleRefresh:handleRefresh,
            handleDraft:updateAuditReport,
            handleReview:handleReview,
            setUpdatedPayrollData:setUpdatedPayrollData,
            handleChangetoZero:handleChangetoZero,
            handlepremitionCancelBtn:handlepremitionCancelBtn
        },
        resolveComponentMap:{
            PayrollReviewGL
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    return  <ViewModelForm
        uiProps={metadata.pageContent}
        model={payrollData}
        overrideProps={overrides}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
    />
}

CPMIStartPayrollGL.defaultProps = {};
export default withRouter(CPMIStartPayrollGL);